module.exports = __webpack_public_path__ + "img/H2.a93afea1.png";